<template>
  <div id="landingpage" class="landing-page" v-hammer:swipe="onPanHorizontal">
    <language-dropdown v-if="this.languageToolbar" class="landing-language-dropdown"></language-dropdown>
    <preloader v-if="showLoader" mode='animate' :background="true"></preloader>
    <div class="landing-wrapper">
      <div id="left-scrollpoint" class="left-scrollpoint" :direction="'left'"></div>
      <div id="middle-scrollpoint" class="middle-scrollpoint" :direction="'middle'"></div>
      <div id="right-scrollpoint" class="right-scrollpoint" :direction="'right'"></div>
      <slot></slot>
      <back-button v-if="this.backButton"></back-button>
    </div>
    <div v-if="isMobile && canScrollLeft" class="landing-scroll-button landing-left is-flex landing-bounce" @click="scroll('left')"><i class="fas fa-chevron-circle-left fa-3x"></i></div>
    <div v-if="isMobile && canScrollRight" class="landing-scroll-button landing-right is-flex landing-bounce" @click="scroll('right')"><i class="fas fa-chevron-circle-right fa-3x"></i></div>
  </div>
</template>

<script>
import Vue from 'vue'
import componentState from '@/mixins/component-state'
import LanguageDropdown from '@/components/Controls/LanguageDropdown'
import userAgent from '@/libs/user-agent'
import mixin from './mixin.js'
import breakpoints from '@/libs/breakpoints'
import BackButton from './BackButton'
import Preloader from '@/components/Controls/Preloader'
import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer)
export default {
  components: {
    LanguageDropdown,
    BackButton,
    Preloader
  },
  data: function () {
    return {
      canScrollRight: true,
      canScrollLeft: false,
      scrollLeft: 0
    }
  },
  props: ['languageToolbar', 'backButton'],
  mixins: [componentState, mixin],
  computed: {
    isSafari: function () {
      return userAgent.isSafari()
    },
    isWidescreenAndUp: function () {
      return breakpoints.isWidescreenAndUp()
    },
    isDesktopAndUp: function () {
      return breakpoints.isDesktopAndUp()
    },
    isIOS: function () {
      return userAgent.isIOS()
    },
    isChrome: function () {
      return userAgent.isChrome()
    }
  },
  mounted: function () {
    if (this.$route.query.create) {
      this.showChooseTemplateModal = true
    }
    if (this.isMobile) {
      this.$nextTick(() => {
        this.canScrollRight = true
        this.canScrollLeft = true
        document.getElementById('middle-scrollpoint').scrollIntoView({
          behavior: this.isSafari || this.isIOS || this.isChrome ? 'auto' : 'smooth',
          block: 'center',
          inline: 'center'
        })
      })
    }
    this.removingShiftAppUp()
  },
  methods: {
    scroll: function (direction) {
      if (direction === 'right' && this.canScrollLeft && this.canScrollRight) {
        this.canScrollRight = false
        this.canScrollLeft = true
        document.getElementById('right-scrollpoint').scrollIntoView({
          behavior: 'auto',
          block: this.isSafari || this.isIOS ? 'center' : 'nearest',
          inline: this.isSafari || this.isIOS ? 'center' : 'nearest'
        })
      } else if (direction === 'left' && this.canScrollLeft && this.canScrollRight) {
        this.canScrollRight = true
        this.canScrollLeft = false
        document.getElementById('left-scrollpoint').scrollIntoView({
          behavior: 'auto',
          block: this.isSafari || this.isIOS ? 'center' : 'nearest',
          inline: this.isSafari || this.isIOS ? 'center' : 'nearest'
        })
      } else if (direction === 'left' && this.canScrollLeft && !this.canScrollRight) {
        this.canScrollRight = true
        this.canScrollLeft = true
        document.getElementById('middle-scrollpoint').scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center'
        })
      } else if (direction === 'right' && !this.canScrollLeft && this.canScrollRight) {
        this.canScrollRight = true
        this.canScrollLeft = true
        document.getElementById('middle-scrollpoint').scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center'
        })
      }
    },
    onPanHorizontal: function (e) {
      const { direction } = e
      direction === 2 && this.scroll('right')
      direction === 4 && this.scroll('left')
    },
    removingShiftAppUp: function () {
      const parent = document.getElementById('landingpage')
      parent.parentNode.classList.add('remove-padding')
    }
  }
}
</script>

<style lang="scss">
  @import '~styles/utils.scss';
  #app .landing-language-dropdown {
    position: absolute !important;
  }

  .left-scrollpoint {
    position: absolute;
    left: 0;
  }
  .middle-scrollpoint {
    position: absolute;
    left: 50%;
  }
  .right-scrollpoint {
    position: absolute;
    left: 100%;
  }

  .landing-page {
    height: calc(100vh - 72px);
    background: var(--color);
    margin: 0 auto;
    min-width: 1000px;
    overflow-y: auto;
    @include mobile {
      -webkit-overflow-scrolling: touch;
      touch-action: pan-y !important;
    }
  }
  .landing-wrapper {
    position: relative;
    min-width: calc(100vh*1.5);
    max-width: calc(100vh*1.5);
    min-height: calc(100vh - 90px);
    margin: 0 auto;
    background: var(--background);
    background-color:  var(--color);
    background-size: contain;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  .landingCursor a:hover, .landingCursor .landing-scroll-button:hover, .landing-scroll-button:hover {
    cursor: pointer;
  }

  .landing-scroll-button {
    width: 3.5rem;
    pointer-events: auto;
    align-items: center;
    justify-content: center;
    padding: 0.6rem 0.1rem;
    position: absolute;
    transition: 0.2s;
    top: calc(50vh - 24px);
    position: absolute;
    right: 0;
    z-index: 20;
    i {
      color: $primary;
      background-color: white;
      border-radius: 25px;
    }
  }
  .landing-left {
    left: 0;
  }
  .landing-right {
    right: 0;
  }

  .landing-bounce {
    -moz-animation: bounce 2s;
    -webkit-animation: bounce 2s;
    animation: bounce 2s;
  }
  .landing-page.shiftAppUp {
    padding-bottom: 0rem !important;
  }

  .landing-page.shiftAppUp {
    padding-bottom: 0rem !important;
  }

  #app .remove-padding.shiftAppUp {
    padding-bottom: 0rem;
  }

</style>
